// Client-safe environment config — usable in both client and server components.
// Keep deployment URLs here so client features share the same configuration.

export const SITE_NAME = 'Minimoes';
export const COMPANY_NAME = `${SITE_NAME}, Inc.`;

// NEXT_PUBLIC_SITE_URL reaches the build via `ENV X=$X`, so an unpassed build arg
// arrives as '' rather than undefined — `??` would keep it and new URL('') throws.
export const SITE_URL = ((): string => {
  try {
    return new URL((process.env.NEXT_PUBLIC_SITE_URL ?? '').trim()).origin;
  } catch {
    return 'https://minimoes.com';
  }
})();

export const AVATAR_BACKEND_URL =
  process.env.NEXT_PUBLIC_AVATAR_BACKEND_URL ?? 'http://localhost:5000';

export const API_URL =
  process.env.NEXT_PUBLIC_API_URL ?? 'http://localhost:5000';

// STT WebSocket base URL — the Authorization token is appended at runtime by
// the client after fetching a short-lived token from /api/stt-token.
// MODAL_API_KEY must NEVER appear in client-side code or NEXT_PUBLIC_ vars.
export const STT_WS_BASE_URL =
  process.env.NEXT_PUBLIC_STT_WS_URL ?? 'ws://localhost:7860/ws/stt';

/**
 * Origine du client avatar — SOURCE UNIQUE.
 *
 * Historiquement deux écrans (obs, live) lisaient `NEXT_PUBLIC_AVATAR_ORIGIN`
 * avec un fallback production figé, pendant que les autres lisaient
 * `NEXT_PUBLIC_AVATAR_CLIENT_URL` avec un fallback localhost. Résultat : en dev,
 * obs/live chargeaient le client de production et les autres le local — deux
 * builds différents pour le même agent.
 *
 * On garde les deux noms en lecture pour ne casser aucun déploiement, mais les
 * deux pointent désormais ici. Personne ne lit les variables directement.
 */
export const AVATAR_CLIENT_URL =
  process.env.NEXT_PUBLIC_AVATAR_CLIENT_URL ||
  process.env.NEXT_PUBLIC_AVATAR_ORIGIN ||
  (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1'
    ? 'https://avatar.minimoes.com'
    : (process.env.NODE_ENV === 'production' ? 'https://avatar.minimoes.com' : 'http://localhost:3000'));
